module.exports = __webpack_public_path__ + "img/SR.cbccf817.svg";